// src/api/nav.js
import request from '@/utils/request';

export const getNavPicName = () => {
  return request({
    url: '/nav/getAllPath',
    method: 'get',
    params: {}, // 明确传递空对象或移除 params
  });
};

export const getIndexProductPicName = () => {
  return request({
    url: '/nav/getProductAllPath',
    method: 'get',
    params: {},
  });
};

export const addNavPic = (data) => {
  return request({
    url: '/nav/add',
    method: 'post',
    data,
  });
};

export const addNavProductPic = (data) => {
  return request({
    url: '/nav/addProductImg',
    method: 'post',
    data,
  });
};